// extracted by mini-css-extract-plugin
module.exports = {"scrollable":"scrollable-a2a39e32","scrollableContent":"scrollableContent-c341f08e","mobile":"mobile-7f6d10df"};